import { connect } from 'react-redux';
import { branch, compose, lifecycle, renderComponent, withHandlers, withState } from 'recompose';
import { NumberShim } from '@packages/helpers/core/shims/number-shim';
import { mapMyPlanChartConfig } from '../../../helpers/my-plan/get-doughnuts-config';
import { mapSimulatedMyPlanChartConfig } from '../../../helpers/my-plan/get-simulated-config';
import { isModuleCompleted } from '../../../helpers/custom-page/is-completed';
import { Doughnuts } from './component';

const tick = NumberShim.loopIn(0, 4);

const SimulatedDoughnuts = compose(
  withState('goals', 'setConfig', mapSimulatedMyPlanChartConfig()),
  withHandlers({
    ticker:
      ({ setConfig }) =>
      () => {
        tick();

        setConfig(goals => {
          return mapSimulatedMyPlanChartConfig(tick.isIterationDone() ? void 0 : goals);
        });
      }
  }),
  lifecycle({
    componentDidMount() {
      const { ticker } = this.props;

      this.interval = setInterval(ticker, 1000);
    },
    componentWillUnmount() {
      clearInterval(this.interval);
    }
  })
)(Doughnuts);

const mapStateToProps = ({ userAttributes }) => ({
  goals: mapMyPlanChartConfig(userAttributes.goal)
});

export const DoughnutsContainer = (Placeholder = SimulatedDoughnuts) => {
  return compose(
    connect(({ statusData }) => ({ isCompleted: isModuleCompleted(statusData, 'myPlan') })),
    branch(({ isCompleted }) => !isCompleted, renderComponent(Placeholder)),
    branch(({ goals }) => !goals, connect(mapStateToProps))
  );
};

export const PlanDoughnuts = DoughnutsContainer()(Doughnuts);
